export default "__VITE_ASSET__Bf4OT3IU__"